// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M_-0e"};